module.exports = __webpack_public_path__ + "img/ToniDunbar.abe46fb4.png";